/**
 * Decimal precision shared by every amount in a proposal summary.
 *
 * Rounding the lines to whole kroner while the total keeps its øre makes the
 * summary look like it cannot add up (a 1 211,20 total under a 1 211 line), so
 * a single fractional amount promotes all of them to two decimals.
 */
export const getProposalSummaryDecimals = (amounts: number[]): 0 | 2 =>
  amounts.some((amount) => Math.round(amount * 100) % 100 !== 0) ? 2 : 0;
